<template>
  <div
    class="metric-block"
    :class="{ 'metric-block-vertical': valuePosition === 'top' }"
  >
    <div class="metric-block-value">
      {{ metric }}
    </div>
    <TitleSection :title="title" :subtitle="subtitle"> </TitleSection>
  </div>
</template>

<script>
export default {
  name: "MetricBlock",

  props: ["metric", "title", "subtitle", "valuePosition"],
};
</script>

<style lang="scss" scoped>
.metric-block {
  display: flex;
  align-items: center;

  &-value {
    font-weight: 300;
    font-size: 46px;
    margin-right: 15px;
    color: #2c3153;
  }

  &-vertical {
    flex-direction: column;
    align-items: start;

    .metric-block-value {
      margin-bottom: 15px;
    }
  }
}
</style>
